import { render, staticRenderFns } from "./zzjf.vue?vue&type=template&id=70d7a277&scoped=true&"
import script from "./zzjf.vue?vue&type=script&lang=js&"
export * from "./zzjf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d7a277",
  null
  
)

export default component.exports